import { createContext, useContext, type FC, type ReactNode } from 'react'
import { type ResultsStore } from 'pages/conversations/pages/search/ui/Results'

export const ResultsContext = createContext<ResultsStore | null>(null)

export const useResultsContext = () => {
  const context = useContext(ResultsContext)

  if (context === null)
    throw new Error('You have forgotten to wrap your root component with ResultsContext')

  return context
}

type IProviderResultsProps = {
  value: ResultsStore
  children: ReactNode
}

export const ProviderResults: FC<IProviderResultsProps> = ({ value, children }) => {
  return <ResultsContext.Provider value={value}>{children}</ResultsContext.Provider>
}
